/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as UserRouteImport } from './routes/user'
import { Route as TeamRouteImport } from './routes/team'
import { Route as SitesRouteImport } from './routes/sites'
import { Route as ResetRouteImport } from './routes/reset'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as MobileAuthChallengeRouteImport } from './routes/mobile-auth-challenge'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotRouteImport } from './routes/forgot'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VerifyIndexRouteImport } from './routes/verify.index'
import { Route as UserIndexRouteImport } from './routes/user.index'
import { Route as SitesIndexRouteImport } from './routes/sites.index'
import { Route as AccountIndexRouteImport } from './routes/account.index'
import { Route as VerifyTokenRouteImport } from './routes/verify.$token'
import { Route as UserAppearanceRouteImport } from './routes/user.appearance'
import { Route as SitesNewRouteImport } from './routes/sites.new'
import { Route as SitesSiteSlugRouteImport } from './routes/sites.$siteSlug'
import { Route as SettingsDatabasesRouteImport } from './routes/settings.databases'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as AccountTeamRouteImport } from './routes/account.team'
import { Route as AccountNotificationsRouteImport } from './routes/account.notifications'
import { Route as AccountConnectionsRouteImport } from './routes/account.connections'
import { Route as AccountBillingRouteImport } from './routes/account.billing'
import { Route as AccountApiKeysRouteImport } from './routes/account.api-keys'
import { Route as AccountAiUsageRouteImport } from './routes/account.ai-usage'
import { Route as AccountAiKeysRouteImport } from './routes/account.ai-keys'
import { Route as SitesSiteSlugIndexRouteImport } from './routes/sites.$siteSlug.index'
import { Route as TemplatesSharedTokenRouteImport } from './routes/templates.shared.$token'
import { Route as SitesSiteSlugVersionsRouteImport } from './routes/sites.$siteSlug.versions'
import { Route as SitesSiteSlugThemeRouteImport } from './routes/sites.$siteSlug.theme'
import { Route as SitesSiteSlugSettingsRouteImport } from './routes/sites.$siteSlug.settings'
import { Route as SitesSiteSlugSearchRouteImport } from './routes/sites.$siteSlug.search'
import { Route as SitesSiteSlugPreviewRouteImport } from './routes/sites.$siteSlug.preview'
import { Route as SitesSiteSlugPlatformsRouteImport } from './routes/sites.$siteSlug.platforms'
import { Route as SitesSiteSlugMigrateRouteImport } from './routes/sites.$siteSlug.migrate'
import { Route as SitesSiteSlugMembersRouteImport } from './routes/sites.$siteSlug.members'
import { Route as SitesSiteSlugMediaRouteImport } from './routes/sites.$siteSlug.media'
import { Route as SitesSiteSlugBarkRouteImport } from './routes/sites.$siteSlug.bark'
import { Route as SitesSiteSlugActivitypubRouteImport } from './routes/sites.$siteSlug.activitypub'
import { Route as SitesSiteSlugSettingsIndexRouteImport } from './routes/sites.$siteSlug.settings.index'
import { Route as SitesSiteSlugPostsIndexRouteImport } from './routes/sites.$siteSlug.posts.index'
import { Route as SitesSiteSlugPagesIndexRouteImport } from './routes/sites.$siteSlug.pages.index'
import { Route as SitesSiteSlugFormsIndexRouteImport } from './routes/sites.$siteSlug.forms.index'
import { Route as SitesSiteSlugContentTypesIndexRouteImport } from './routes/sites.$siteSlug.content-types.index'
import { Route as SitesSiteSlugThemeDesignRouteImport } from './routes/sites.$siteSlug.theme_.design'
import { Route as SitesSiteSlugSettingsLanguagesRouteImport } from './routes/sites.$siteSlug.settings.languages'
import { Route as SitesSiteSlugSettingsGenerationRouteImport } from './routes/sites.$siteSlug.settings.generation'
import { Route as SitesSiteSlugSettingsEmailRouteImport } from './routes/sites.$siteSlug.settings.email'
import { Route as SitesSiteSlugSettingsDatabasesRouteImport } from './routes/sites.$siteSlug.settings.databases'
import { Route as SitesSiteSlugSettingsApiKeysRouteImport } from './routes/sites.$siteSlug.settings.api-keys'
import { Route as SitesSiteSlugPostsNewRouteImport } from './routes/sites.$siteSlug.posts.new'
import { Route as SitesSiteSlugPostsPostIdRouteImport } from './routes/sites.$siteSlug.posts.$postId'
import { Route as SitesSiteSlugPagesNewRouteImport } from './routes/sites.$siteSlug.pages.new'
import { Route as SitesSiteSlugPagesPageIdRouteImport } from './routes/sites.$siteSlug.pages.$pageId'
import { Route as SitesSiteSlugFormsNewRouteImport } from './routes/sites.$siteSlug.forms.new'
import { Route as SitesSiteSlugFormsFormIdRouteImport } from './routes/sites.$siteSlug.forms.$formId'
import { Route as SitesSiteSlugContentTypesTablesRouteImport } from './routes/sites.$siteSlug.content-types.tables'
import { Route as SitesSiteSlugContentTypesNewRouteImport } from './routes/sites.$siteSlug.content-types.new'
import { Route as SitesSiteSlugContentTypesTypeSlugRouteImport } from './routes/sites.$siteSlug.content-types.$typeSlug'
import { Route as SitesSiteSlugFormsFormIdIndexRouteImport } from './routes/sites.$siteSlug.forms.$formId.index'
import { Route as SitesSiteSlugContentTypesTablesIndexRouteImport } from './routes/sites.$siteSlug.content-types.tables.index'
import { Route as SitesSiteSlugPagesPageIdDesignRouteImport } from './routes/sites.$siteSlug.pages.$pageId_.design'
import { Route as SitesSiteSlugFormsFormIdSubmissionsRouteImport } from './routes/sites.$siteSlug.forms.$formId.submissions'
import { Route as SitesSiteSlugContentTypesTablesTypeSlugRouteImport } from './routes/sites.$siteSlug.content-types.tables.$typeSlug'
import { Route as SitesSiteSlugContentTypesTablesTypeSlugIndexRouteImport } from './routes/sites.$siteSlug.content-types.tables.$typeSlug.index'
import { Route as SitesSiteSlugContentTypesTablesTypeSlugNewRouteImport } from './routes/sites.$siteSlug.content-types.tables.$typeSlug.new'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const UserRoute = UserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamRoute = TeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => rootRouteImport,
} as any)
const SitesRoute = SitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetRoute = ResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileAuthChallengeRoute = MobileAuthChallengeRouteImport.update({
  id: '/mobile-auth-challenge',
  path: '/mobile-auth-challenge',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotRoute = ForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyIndexRoute = VerifyIndexRouteImport.update({
  id: '/verify/',
  path: '/verify/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserIndexRoute = UserIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UserRoute,
} as any)
const SitesIndexRoute = SitesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SitesRoute,
} as any)
const AccountIndexRoute = AccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountRoute,
} as any)
const VerifyTokenRoute = VerifyTokenRouteImport.update({
  id: '/verify/$token',
  path: '/verify/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const UserAppearanceRoute = UserAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => UserRoute,
} as any)
const SitesNewRoute = SitesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => SitesRoute,
} as any)
const SitesSiteSlugRoute = SitesSiteSlugRouteImport.update({
  id: '/$siteSlug',
  path: '/$siteSlug',
  getParentRoute: () => SitesRoute,
} as any)
const SettingsDatabasesRoute = SettingsDatabasesRouteImport.update({
  id: '/settings/databases',
  path: '/settings/databases',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountTeamRoute = AccountTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AccountRoute,
} as any)
const AccountNotificationsRoute = AccountNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AccountRoute,
} as any)
const AccountConnectionsRoute = AccountConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => AccountRoute,
} as any)
const AccountBillingRoute = AccountBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AccountRoute,
} as any)
const AccountApiKeysRoute = AccountApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AccountRoute,
} as any)
const AccountAiUsageRoute = AccountAiUsageRouteImport.update({
  id: '/ai-usage',
  path: '/ai-usage',
  getParentRoute: () => AccountRoute,
} as any)
const AccountAiKeysRoute = AccountAiKeysRouteImport.update({
  id: '/ai-keys',
  path: '/ai-keys',
  getParentRoute: () => AccountRoute,
} as any)
const SitesSiteSlugIndexRoute = SitesSiteSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const TemplatesSharedTokenRoute = TemplatesSharedTokenRouteImport.update({
  id: '/templates/shared/$token',
  path: '/templates/shared/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SitesSiteSlugVersionsRoute = SitesSiteSlugVersionsRouteImport.update({
  id: '/versions',
  path: '/versions',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const SitesSiteSlugThemeRoute = SitesSiteSlugThemeRouteImport.update({
  id: '/theme',
  path: '/theme',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const SitesSiteSlugSettingsRoute = SitesSiteSlugSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const SitesSiteSlugSearchRoute = SitesSiteSlugSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const SitesSiteSlugPreviewRoute = SitesSiteSlugPreviewRouteImport.update({
  id: '/preview',
  path: '/preview',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const SitesSiteSlugPlatformsRoute = SitesSiteSlugPlatformsRouteImport.update({
  id: '/platforms',
  path: '/platforms',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const SitesSiteSlugMigrateRoute = SitesSiteSlugMigrateRouteImport.update({
  id: '/migrate',
  path: '/migrate',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const SitesSiteSlugMembersRoute = SitesSiteSlugMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const SitesSiteSlugMediaRoute = SitesSiteSlugMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const SitesSiteSlugBarkRoute = SitesSiteSlugBarkRouteImport.update({
  id: '/bark',
  path: '/bark',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const SitesSiteSlugActivitypubRoute =
  SitesSiteSlugActivitypubRouteImport.update({
    id: '/activitypub',
    path: '/activitypub',
    getParentRoute: () => SitesSiteSlugRoute,
  } as any)
const SitesSiteSlugSettingsIndexRoute =
  SitesSiteSlugSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SitesSiteSlugSettingsRoute,
  } as any)
const SitesSiteSlugPostsIndexRoute = SitesSiteSlugPostsIndexRouteImport.update({
  id: '/posts/',
  path: '/posts/',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const SitesSiteSlugPagesIndexRoute = SitesSiteSlugPagesIndexRouteImport.update({
  id: '/pages/',
  path: '/pages/',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const SitesSiteSlugFormsIndexRoute = SitesSiteSlugFormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const SitesSiteSlugContentTypesIndexRoute =
  SitesSiteSlugContentTypesIndexRouteImport.update({
    id: '/content-types/',
    path: '/content-types/',
    getParentRoute: () => SitesSiteSlugRoute,
  } as any)
const SitesSiteSlugThemeDesignRoute =
  SitesSiteSlugThemeDesignRouteImport.update({
    id: '/theme_/design',
    path: '/theme/design',
    getParentRoute: () => SitesSiteSlugRoute,
  } as any)
const SitesSiteSlugSettingsLanguagesRoute =
  SitesSiteSlugSettingsLanguagesRouteImport.update({
    id: '/languages',
    path: '/languages',
    getParentRoute: () => SitesSiteSlugSettingsRoute,
  } as any)
const SitesSiteSlugSettingsGenerationRoute =
  SitesSiteSlugSettingsGenerationRouteImport.update({
    id: '/generation',
    path: '/generation',
    getParentRoute: () => SitesSiteSlugSettingsRoute,
  } as any)
const SitesSiteSlugSettingsEmailRoute =
  SitesSiteSlugSettingsEmailRouteImport.update({
    id: '/email',
    path: '/email',
    getParentRoute: () => SitesSiteSlugSettingsRoute,
  } as any)
const SitesSiteSlugSettingsDatabasesRoute =
  SitesSiteSlugSettingsDatabasesRouteImport.update({
    id: '/databases',
    path: '/databases',
    getParentRoute: () => SitesSiteSlugSettingsRoute,
  } as any)
const SitesSiteSlugSettingsApiKeysRoute =
  SitesSiteSlugSettingsApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => SitesSiteSlugSettingsRoute,
  } as any)
const SitesSiteSlugPostsNewRoute = SitesSiteSlugPostsNewRouteImport.update({
  id: '/posts/new',
  path: '/posts/new',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const SitesSiteSlugPostsPostIdRoute =
  SitesSiteSlugPostsPostIdRouteImport.update({
    id: '/posts/$postId',
    path: '/posts/$postId',
    getParentRoute: () => SitesSiteSlugRoute,
  } as any)
const SitesSiteSlugPagesNewRoute = SitesSiteSlugPagesNewRouteImport.update({
  id: '/pages/new',
  path: '/pages/new',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const SitesSiteSlugPagesPageIdRoute =
  SitesSiteSlugPagesPageIdRouteImport.update({
    id: '/pages/$pageId',
    path: '/pages/$pageId',
    getParentRoute: () => SitesSiteSlugRoute,
  } as any)
const SitesSiteSlugFormsNewRoute = SitesSiteSlugFormsNewRouteImport.update({
  id: '/forms/new',
  path: '/forms/new',
  getParentRoute: () => SitesSiteSlugRoute,
} as any)
const SitesSiteSlugFormsFormIdRoute =
  SitesSiteSlugFormsFormIdRouteImport.update({
    id: '/forms/$formId',
    path: '/forms/$formId',
    getParentRoute: () => SitesSiteSlugRoute,
  } as any)
const SitesSiteSlugContentTypesTablesRoute =
  SitesSiteSlugContentTypesTablesRouteImport.update({
    id: '/content-types/tables',
    path: '/content-types/tables',
    getParentRoute: () => SitesSiteSlugRoute,
  } as any)
const SitesSiteSlugContentTypesNewRoute =
  SitesSiteSlugContentTypesNewRouteImport.update({
    id: '/content-types/new',
    path: '/content-types/new',
    getParentRoute: () => SitesSiteSlugRoute,
  } as any)
const SitesSiteSlugContentTypesTypeSlugRoute =
  SitesSiteSlugContentTypesTypeSlugRouteImport.update({
    id: '/content-types/$typeSlug',
    path: '/content-types/$typeSlug',
    getParentRoute: () => SitesSiteSlugRoute,
  } as any)
const SitesSiteSlugFormsFormIdIndexRoute =
  SitesSiteSlugFormsFormIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SitesSiteSlugFormsFormIdRoute,
  } as any)
const SitesSiteSlugContentTypesTablesIndexRoute =
  SitesSiteSlugContentTypesTablesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SitesSiteSlugContentTypesTablesRoute,
  } as any)
const SitesSiteSlugPagesPageIdDesignRoute =
  SitesSiteSlugPagesPageIdDesignRouteImport.update({
    id: '/pages/$pageId_/design',
    path: '/pages/$pageId/design',
    getParentRoute: () => SitesSiteSlugRoute,
  } as any)
const SitesSiteSlugFormsFormIdSubmissionsRoute =
  SitesSiteSlugFormsFormIdSubmissionsRouteImport.update({
    id: '/submissions',
    path: '/submissions',
    getParentRoute: () => SitesSiteSlugFormsFormIdRoute,
  } as any)
const SitesSiteSlugContentTypesTablesTypeSlugRoute =
  SitesSiteSlugContentTypesTablesTypeSlugRouteImport.update({
    id: '/$typeSlug',
    path: '/$typeSlug',
    getParentRoute: () => SitesSiteSlugContentTypesTablesRoute,
  } as any)
const SitesSiteSlugContentTypesTablesTypeSlugIndexRoute =
  SitesSiteSlugContentTypesTablesTypeSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SitesSiteSlugContentTypesTablesTypeSlugRoute,
  } as any)
const SitesSiteSlugContentTypesTablesTypeSlugNewRoute =
  SitesSiteSlugContentTypesTablesTypeSlugNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => SitesSiteSlugContentTypesTablesTypeSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRouteWithChildren
  '/billing': typeof BillingRoute
  '/forgot': typeof ForgotRoute
  '/login': typeof LoginRoute
  '/mobile-auth-challenge': typeof MobileAuthChallengeRoute
  '/notifications': typeof NotificationsRoute
  '/register': typeof RegisterRoute
  '/reset': typeof ResetRoute
  '/sites': typeof SitesRouteWithChildren
  '/team': typeof TeamRoute
  '/user': typeof UserRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/account/ai-keys': typeof AccountAiKeysRoute
  '/account/ai-usage': typeof AccountAiUsageRoute
  '/account/api-keys': typeof AccountApiKeysRoute
  '/account/billing': typeof AccountBillingRoute
  '/account/connections': typeof AccountConnectionsRoute
  '/account/notifications': typeof AccountNotificationsRoute
  '/account/team': typeof AccountTeamRoute
  '/invite/$token': typeof InviteTokenRoute
  '/settings/databases': typeof SettingsDatabasesRoute
  '/sites/$siteSlug': typeof SitesSiteSlugRouteWithChildren
  '/sites/new': typeof SitesNewRoute
  '/user/appearance': typeof UserAppearanceRoute
  '/verify/$token': typeof VerifyTokenRoute
  '/account/': typeof AccountIndexRoute
  '/sites/': typeof SitesIndexRoute
  '/user/': typeof UserIndexRoute
  '/verify': typeof VerifyIndexRoute
  '/sites/$siteSlug/activitypub': typeof SitesSiteSlugActivitypubRoute
  '/sites/$siteSlug/bark': typeof SitesSiteSlugBarkRoute
  '/sites/$siteSlug/media': typeof SitesSiteSlugMediaRoute
  '/sites/$siteSlug/members': typeof SitesSiteSlugMembersRoute
  '/sites/$siteSlug/migrate': typeof SitesSiteSlugMigrateRoute
  '/sites/$siteSlug/platforms': typeof SitesSiteSlugPlatformsRoute
  '/sites/$siteSlug/preview': typeof SitesSiteSlugPreviewRoute
  '/sites/$siteSlug/search': typeof SitesSiteSlugSearchRoute
  '/sites/$siteSlug/settings': typeof SitesSiteSlugSettingsRouteWithChildren
  '/sites/$siteSlug/theme': typeof SitesSiteSlugThemeRoute
  '/sites/$siteSlug/versions': typeof SitesSiteSlugVersionsRoute
  '/templates/shared/$token': typeof TemplatesSharedTokenRoute
  '/sites/$siteSlug/': typeof SitesSiteSlugIndexRoute
  '/sites/$siteSlug/content-types/$typeSlug': typeof SitesSiteSlugContentTypesTypeSlugRoute
  '/sites/$siteSlug/content-types/new': typeof SitesSiteSlugContentTypesNewRoute
  '/sites/$siteSlug/content-types/tables': typeof SitesSiteSlugContentTypesTablesRouteWithChildren
  '/sites/$siteSlug/forms/$formId': typeof SitesSiteSlugFormsFormIdRouteWithChildren
  '/sites/$siteSlug/forms/new': typeof SitesSiteSlugFormsNewRoute
  '/sites/$siteSlug/pages/$pageId': typeof SitesSiteSlugPagesPageIdRoute
  '/sites/$siteSlug/pages/new': typeof SitesSiteSlugPagesNewRoute
  '/sites/$siteSlug/posts/$postId': typeof SitesSiteSlugPostsPostIdRoute
  '/sites/$siteSlug/posts/new': typeof SitesSiteSlugPostsNewRoute
  '/sites/$siteSlug/settings/api-keys': typeof SitesSiteSlugSettingsApiKeysRoute
  '/sites/$siteSlug/settings/databases': typeof SitesSiteSlugSettingsDatabasesRoute
  '/sites/$siteSlug/settings/email': typeof SitesSiteSlugSettingsEmailRoute
  '/sites/$siteSlug/settings/generation': typeof SitesSiteSlugSettingsGenerationRoute
  '/sites/$siteSlug/settings/languages': typeof SitesSiteSlugSettingsLanguagesRoute
  '/sites/$siteSlug/theme/design': typeof SitesSiteSlugThemeDesignRoute
  '/sites/$siteSlug/content-types': typeof SitesSiteSlugContentTypesIndexRoute
  '/sites/$siteSlug/forms': typeof SitesSiteSlugFormsIndexRoute
  '/sites/$siteSlug/pages': typeof SitesSiteSlugPagesIndexRoute
  '/sites/$siteSlug/posts': typeof SitesSiteSlugPostsIndexRoute
  '/sites/$siteSlug/settings/': typeof SitesSiteSlugSettingsIndexRoute
  '/sites/$siteSlug/content-types/tables/$typeSlug': typeof SitesSiteSlugContentTypesTablesTypeSlugRouteWithChildren
  '/sites/$siteSlug/forms/$formId/submissions': typeof SitesSiteSlugFormsFormIdSubmissionsRoute
  '/sites/$siteSlug/pages/$pageId/design': typeof SitesSiteSlugPagesPageIdDesignRoute
  '/sites/$siteSlug/content-types/tables/': typeof SitesSiteSlugContentTypesTablesIndexRoute
  '/sites/$siteSlug/forms/$formId/': typeof SitesSiteSlugFormsFormIdIndexRoute
  '/sites/$siteSlug/content-types/tables/$typeSlug/new': typeof SitesSiteSlugContentTypesTablesTypeSlugNewRoute
  '/sites/$siteSlug/content-types/tables/$typeSlug/': typeof SitesSiteSlugContentTypesTablesTypeSlugIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/billing': typeof BillingRoute
  '/forgot': typeof ForgotRoute
  '/login': typeof LoginRoute
  '/mobile-auth-challenge': typeof MobileAuthChallengeRoute
  '/notifications': typeof NotificationsRoute
  '/register': typeof RegisterRoute
  '/reset': typeof ResetRoute
  '/team': typeof TeamRoute
  '/verify-email': typeof VerifyEmailRoute
  '/account/ai-keys': typeof AccountAiKeysRoute
  '/account/ai-usage': typeof AccountAiUsageRoute
  '/account/api-keys': typeof AccountApiKeysRoute
  '/account/billing': typeof AccountBillingRoute
  '/account/connections': typeof AccountConnectionsRoute
  '/account/notifications': typeof AccountNotificationsRoute
  '/account/team': typeof AccountTeamRoute
  '/invite/$token': typeof InviteTokenRoute
  '/settings/databases': typeof SettingsDatabasesRoute
  '/sites/new': typeof SitesNewRoute
  '/user/appearance': typeof UserAppearanceRoute
  '/verify/$token': typeof VerifyTokenRoute
  '/account': typeof AccountIndexRoute
  '/sites': typeof SitesIndexRoute
  '/user': typeof UserIndexRoute
  '/verify': typeof VerifyIndexRoute
  '/sites/$siteSlug/activitypub': typeof SitesSiteSlugActivitypubRoute
  '/sites/$siteSlug/bark': typeof SitesSiteSlugBarkRoute
  '/sites/$siteSlug/media': typeof SitesSiteSlugMediaRoute
  '/sites/$siteSlug/members': typeof SitesSiteSlugMembersRoute
  '/sites/$siteSlug/migrate': typeof SitesSiteSlugMigrateRoute
  '/sites/$siteSlug/platforms': typeof SitesSiteSlugPlatformsRoute
  '/sites/$siteSlug/preview': typeof SitesSiteSlugPreviewRoute
  '/sites/$siteSlug/search': typeof SitesSiteSlugSearchRoute
  '/sites/$siteSlug/theme': typeof SitesSiteSlugThemeRoute
  '/sites/$siteSlug/versions': typeof SitesSiteSlugVersionsRoute
  '/templates/shared/$token': typeof TemplatesSharedTokenRoute
  '/sites/$siteSlug': typeof SitesSiteSlugIndexRoute
  '/sites/$siteSlug/content-types/$typeSlug': typeof SitesSiteSlugContentTypesTypeSlugRoute
  '/sites/$siteSlug/content-types/new': typeof SitesSiteSlugContentTypesNewRoute
  '/sites/$siteSlug/forms/new': typeof SitesSiteSlugFormsNewRoute
  '/sites/$siteSlug/pages/$pageId': typeof SitesSiteSlugPagesPageIdRoute
  '/sites/$siteSlug/pages/new': typeof SitesSiteSlugPagesNewRoute
  '/sites/$siteSlug/posts/$postId': typeof SitesSiteSlugPostsPostIdRoute
  '/sites/$siteSlug/posts/new': typeof SitesSiteSlugPostsNewRoute
  '/sites/$siteSlug/settings/api-keys': typeof SitesSiteSlugSettingsApiKeysRoute
  '/sites/$siteSlug/settings/databases': typeof SitesSiteSlugSettingsDatabasesRoute
  '/sites/$siteSlug/settings/email': typeof SitesSiteSlugSettingsEmailRoute
  '/sites/$siteSlug/settings/generation': typeof SitesSiteSlugSettingsGenerationRoute
  '/sites/$siteSlug/settings/languages': typeof SitesSiteSlugSettingsLanguagesRoute
  '/sites/$siteSlug/theme/design': typeof SitesSiteSlugThemeDesignRoute
  '/sites/$siteSlug/content-types': typeof SitesSiteSlugContentTypesIndexRoute
  '/sites/$siteSlug/forms': typeof SitesSiteSlugFormsIndexRoute
  '/sites/$siteSlug/pages': typeof SitesSiteSlugPagesIndexRoute
  '/sites/$siteSlug/posts': typeof SitesSiteSlugPostsIndexRoute
  '/sites/$siteSlug/settings': typeof SitesSiteSlugSettingsIndexRoute
  '/sites/$siteSlug/forms/$formId/submissions': typeof SitesSiteSlugFormsFormIdSubmissionsRoute
  '/sites/$siteSlug/pages/$pageId/design': typeof SitesSiteSlugPagesPageIdDesignRoute
  '/sites/$siteSlug/content-types/tables': typeof SitesSiteSlugContentTypesTablesIndexRoute
  '/sites/$siteSlug/forms/$formId': typeof SitesSiteSlugFormsFormIdIndexRoute
  '/sites/$siteSlug/content-types/tables/$typeSlug/new': typeof SitesSiteSlugContentTypesTablesTypeSlugNewRoute
  '/sites/$siteSlug/content-types/tables/$typeSlug': typeof SitesSiteSlugContentTypesTablesTypeSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRouteWithChildren
  '/billing': typeof BillingRoute
  '/forgot': typeof ForgotRoute
  '/login': typeof LoginRoute
  '/mobile-auth-challenge': typeof MobileAuthChallengeRoute
  '/notifications': typeof NotificationsRoute
  '/register': typeof RegisterRoute
  '/reset': typeof ResetRoute
  '/sites': typeof SitesRouteWithChildren
  '/team': typeof TeamRoute
  '/user': typeof UserRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/account/ai-keys': typeof AccountAiKeysRoute
  '/account/ai-usage': typeof AccountAiUsageRoute
  '/account/api-keys': typeof AccountApiKeysRoute
  '/account/billing': typeof AccountBillingRoute
  '/account/connections': typeof AccountConnectionsRoute
  '/account/notifications': typeof AccountNotificationsRoute
  '/account/team': typeof AccountTeamRoute
  '/invite/$token': typeof InviteTokenRoute
  '/settings/databases': typeof SettingsDatabasesRoute
  '/sites/$siteSlug': typeof SitesSiteSlugRouteWithChildren
  '/sites/new': typeof SitesNewRoute
  '/user/appearance': typeof UserAppearanceRoute
  '/verify/$token': typeof VerifyTokenRoute
  '/account/': typeof AccountIndexRoute
  '/sites/': typeof SitesIndexRoute
  '/user/': typeof UserIndexRoute
  '/verify/': typeof VerifyIndexRoute
  '/sites/$siteSlug/activitypub': typeof SitesSiteSlugActivitypubRoute
  '/sites/$siteSlug/bark': typeof SitesSiteSlugBarkRoute
  '/sites/$siteSlug/media': typeof SitesSiteSlugMediaRoute
  '/sites/$siteSlug/members': typeof SitesSiteSlugMembersRoute
  '/sites/$siteSlug/migrate': typeof SitesSiteSlugMigrateRoute
  '/sites/$siteSlug/platforms': typeof SitesSiteSlugPlatformsRoute
  '/sites/$siteSlug/preview': typeof SitesSiteSlugPreviewRoute
  '/sites/$siteSlug/search': typeof SitesSiteSlugSearchRoute
  '/sites/$siteSlug/settings': typeof SitesSiteSlugSettingsRouteWithChildren
  '/sites/$siteSlug/theme': typeof SitesSiteSlugThemeRoute
  '/sites/$siteSlug/versions': typeof SitesSiteSlugVersionsRoute
  '/templates/shared/$token': typeof TemplatesSharedTokenRoute
  '/sites/$siteSlug/': typeof SitesSiteSlugIndexRoute
  '/sites/$siteSlug/content-types/$typeSlug': typeof SitesSiteSlugContentTypesTypeSlugRoute
  '/sites/$siteSlug/content-types/new': typeof SitesSiteSlugContentTypesNewRoute
  '/sites/$siteSlug/content-types/tables': typeof SitesSiteSlugContentTypesTablesRouteWithChildren
  '/sites/$siteSlug/forms/$formId': typeof SitesSiteSlugFormsFormIdRouteWithChildren
  '/sites/$siteSlug/forms/new': typeof SitesSiteSlugFormsNewRoute
  '/sites/$siteSlug/pages/$pageId': typeof SitesSiteSlugPagesPageIdRoute
  '/sites/$siteSlug/pages/new': typeof SitesSiteSlugPagesNewRoute
  '/sites/$siteSlug/posts/$postId': typeof SitesSiteSlugPostsPostIdRoute
  '/sites/$siteSlug/posts/new': typeof SitesSiteSlugPostsNewRoute
  '/sites/$siteSlug/settings/api-keys': typeof SitesSiteSlugSettingsApiKeysRoute
  '/sites/$siteSlug/settings/databases': typeof SitesSiteSlugSettingsDatabasesRoute
  '/sites/$siteSlug/settings/email': typeof SitesSiteSlugSettingsEmailRoute
  '/sites/$siteSlug/settings/generation': typeof SitesSiteSlugSettingsGenerationRoute
  '/sites/$siteSlug/settings/languages': typeof SitesSiteSlugSettingsLanguagesRoute
  '/sites/$siteSlug/theme_/design': typeof SitesSiteSlugThemeDesignRoute
  '/sites/$siteSlug/content-types/': typeof SitesSiteSlugContentTypesIndexRoute
  '/sites/$siteSlug/forms/': typeof SitesSiteSlugFormsIndexRoute
  '/sites/$siteSlug/pages/': typeof SitesSiteSlugPagesIndexRoute
  '/sites/$siteSlug/posts/': typeof SitesSiteSlugPostsIndexRoute
  '/sites/$siteSlug/settings/': typeof SitesSiteSlugSettingsIndexRoute
  '/sites/$siteSlug/content-types/tables/$typeSlug': typeof SitesSiteSlugContentTypesTablesTypeSlugRouteWithChildren
  '/sites/$siteSlug/forms/$formId/submissions': typeof SitesSiteSlugFormsFormIdSubmissionsRoute
  '/sites/$siteSlug/pages/$pageId_/design': typeof SitesSiteSlugPagesPageIdDesignRoute
  '/sites/$siteSlug/content-types/tables/': typeof SitesSiteSlugContentTypesTablesIndexRoute
  '/sites/$siteSlug/forms/$formId/': typeof SitesSiteSlugFormsFormIdIndexRoute
  '/sites/$siteSlug/content-types/tables/$typeSlug/new': typeof SitesSiteSlugContentTypesTablesTypeSlugNewRoute
  '/sites/$siteSlug/content-types/tables/$typeSlug/': typeof SitesSiteSlugContentTypesTablesTypeSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/account'
    | '/billing'
    | '/forgot'
    | '/login'
    | '/mobile-auth-challenge'
    | '/notifications'
    | '/register'
    | '/reset'
    | '/sites'
    | '/team'
    | '/user'
    | '/verify-email'
    | '/account/ai-keys'
    | '/account/ai-usage'
    | '/account/api-keys'
    | '/account/billing'
    | '/account/connections'
    | '/account/notifications'
    | '/account/team'
    | '/invite/$token'
    | '/settings/databases'
    | '/sites/$siteSlug'
    | '/sites/new'
    | '/user/appearance'
    | '/verify/$token'
    | '/account/'
    | '/sites/'
    | '/user/'
    | '/verify'
    | '/sites/$siteSlug/activitypub'
    | '/sites/$siteSlug/bark'
    | '/sites/$siteSlug/media'
    | '/sites/$siteSlug/members'
    | '/sites/$siteSlug/migrate'
    | '/sites/$siteSlug/platforms'
    | '/sites/$siteSlug/preview'
    | '/sites/$siteSlug/search'
    | '/sites/$siteSlug/settings'
    | '/sites/$siteSlug/theme'
    | '/sites/$siteSlug/versions'
    | '/templates/shared/$token'
    | '/sites/$siteSlug/'
    | '/sites/$siteSlug/content-types/$typeSlug'
    | '/sites/$siteSlug/content-types/new'
    | '/sites/$siteSlug/content-types/tables'
    | '/sites/$siteSlug/forms/$formId'
    | '/sites/$siteSlug/forms/new'
    | '/sites/$siteSlug/pages/$pageId'
    | '/sites/$siteSlug/pages/new'
    | '/sites/$siteSlug/posts/$postId'
    | '/sites/$siteSlug/posts/new'
    | '/sites/$siteSlug/settings/api-keys'
    | '/sites/$siteSlug/settings/databases'
    | '/sites/$siteSlug/settings/email'
    | '/sites/$siteSlug/settings/generation'
    | '/sites/$siteSlug/settings/languages'
    | '/sites/$siteSlug/theme/design'
    | '/sites/$siteSlug/content-types'
    | '/sites/$siteSlug/forms'
    | '/sites/$siteSlug/pages'
    | '/sites/$siteSlug/posts'
    | '/sites/$siteSlug/settings/'
    | '/sites/$siteSlug/content-types/tables/$typeSlug'
    | '/sites/$siteSlug/forms/$formId/submissions'
    | '/sites/$siteSlug/pages/$pageId/design'
    | '/sites/$siteSlug/content-types/tables/'
    | '/sites/$siteSlug/forms/$formId/'
    | '/sites/$siteSlug/content-types/tables/$typeSlug/new'
    | '/sites/$siteSlug/content-types/tables/$typeSlug/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/billing'
    | '/forgot'
    | '/login'
    | '/mobile-auth-challenge'
    | '/notifications'
    | '/register'
    | '/reset'
    | '/team'
    | '/verify-email'
    | '/account/ai-keys'
    | '/account/ai-usage'
    | '/account/api-keys'
    | '/account/billing'
    | '/account/connections'
    | '/account/notifications'
    | '/account/team'
    | '/invite/$token'
    | '/settings/databases'
    | '/sites/new'
    | '/user/appearance'
    | '/verify/$token'
    | '/account'
    | '/sites'
    | '/user'
    | '/verify'
    | '/sites/$siteSlug/activitypub'
    | '/sites/$siteSlug/bark'
    | '/sites/$siteSlug/media'
    | '/sites/$siteSlug/members'
    | '/sites/$siteSlug/migrate'
    | '/sites/$siteSlug/platforms'
    | '/sites/$siteSlug/preview'
    | '/sites/$siteSlug/search'
    | '/sites/$siteSlug/theme'
    | '/sites/$siteSlug/versions'
    | '/templates/shared/$token'
    | '/sites/$siteSlug'
    | '/sites/$siteSlug/content-types/$typeSlug'
    | '/sites/$siteSlug/content-types/new'
    | '/sites/$siteSlug/forms/new'
    | '/sites/$siteSlug/pages/$pageId'
    | '/sites/$siteSlug/pages/new'
    | '/sites/$siteSlug/posts/$postId'
    | '/sites/$siteSlug/posts/new'
    | '/sites/$siteSlug/settings/api-keys'
    | '/sites/$siteSlug/settings/databases'
    | '/sites/$siteSlug/settings/email'
    | '/sites/$siteSlug/settings/generation'
    | '/sites/$siteSlug/settings/languages'
    | '/sites/$siteSlug/theme/design'
    | '/sites/$siteSlug/content-types'
    | '/sites/$siteSlug/forms'
    | '/sites/$siteSlug/pages'
    | '/sites/$siteSlug/posts'
    | '/sites/$siteSlug/settings'
    | '/sites/$siteSlug/forms/$formId/submissions'
    | '/sites/$siteSlug/pages/$pageId/design'
    | '/sites/$siteSlug/content-types/tables'
    | '/sites/$siteSlug/forms/$formId'
    | '/sites/$siteSlug/content-types/tables/$typeSlug/new'
    | '/sites/$siteSlug/content-types/tables/$typeSlug'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/account'
    | '/billing'
    | '/forgot'
    | '/login'
    | '/mobile-auth-challenge'
    | '/notifications'
    | '/register'
    | '/reset'
    | '/sites'
    | '/team'
    | '/user'
    | '/verify-email'
    | '/account/ai-keys'
    | '/account/ai-usage'
    | '/account/api-keys'
    | '/account/billing'
    | '/account/connections'
    | '/account/notifications'
    | '/account/team'
    | '/invite/$token'
    | '/settings/databases'
    | '/sites/$siteSlug'
    | '/sites/new'
    | '/user/appearance'
    | '/verify/$token'
    | '/account/'
    | '/sites/'
    | '/user/'
    | '/verify/'
    | '/sites/$siteSlug/activitypub'
    | '/sites/$siteSlug/bark'
    | '/sites/$siteSlug/media'
    | '/sites/$siteSlug/members'
    | '/sites/$siteSlug/migrate'
    | '/sites/$siteSlug/platforms'
    | '/sites/$siteSlug/preview'
    | '/sites/$siteSlug/search'
    | '/sites/$siteSlug/settings'
    | '/sites/$siteSlug/theme'
    | '/sites/$siteSlug/versions'
    | '/templates/shared/$token'
    | '/sites/$siteSlug/'
    | '/sites/$siteSlug/content-types/$typeSlug'
    | '/sites/$siteSlug/content-types/new'
    | '/sites/$siteSlug/content-types/tables'
    | '/sites/$siteSlug/forms/$formId'
    | '/sites/$siteSlug/forms/new'
    | '/sites/$siteSlug/pages/$pageId'
    | '/sites/$siteSlug/pages/new'
    | '/sites/$siteSlug/posts/$postId'
    | '/sites/$siteSlug/posts/new'
    | '/sites/$siteSlug/settings/api-keys'
    | '/sites/$siteSlug/settings/databases'
    | '/sites/$siteSlug/settings/email'
    | '/sites/$siteSlug/settings/generation'
    | '/sites/$siteSlug/settings/languages'
    | '/sites/$siteSlug/theme_/design'
    | '/sites/$siteSlug/content-types/'
    | '/sites/$siteSlug/forms/'
    | '/sites/$siteSlug/pages/'
    | '/sites/$siteSlug/posts/'
    | '/sites/$siteSlug/settings/'
    | '/sites/$siteSlug/content-types/tables/$typeSlug'
    | '/sites/$siteSlug/forms/$formId/submissions'
    | '/sites/$siteSlug/pages/$pageId_/design'
    | '/sites/$siteSlug/content-types/tables/'
    | '/sites/$siteSlug/forms/$formId/'
    | '/sites/$siteSlug/content-types/tables/$typeSlug/new'
    | '/sites/$siteSlug/content-types/tables/$typeSlug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AccountRoute: typeof AccountRouteWithChildren
  BillingRoute: typeof BillingRoute
  ForgotRoute: typeof ForgotRoute
  LoginRoute: typeof LoginRoute
  MobileAuthChallengeRoute: typeof MobileAuthChallengeRoute
  NotificationsRoute: typeof NotificationsRoute
  RegisterRoute: typeof RegisterRoute
  ResetRoute: typeof ResetRoute
  SitesRoute: typeof SitesRouteWithChildren
  TeamRoute: typeof TeamRoute
  UserRoute: typeof UserRouteWithChildren
  VerifyEmailRoute: typeof VerifyEmailRoute
  InviteTokenRoute: typeof InviteTokenRoute
  SettingsDatabasesRoute: typeof SettingsDatabasesRoute
  VerifyTokenRoute: typeof VerifyTokenRoute
  VerifyIndexRoute: typeof VerifyIndexRoute
  TemplatesSharedTokenRoute: typeof TemplatesSharedTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user': {
      id: '/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof UserRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team': {
      id: '/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof TeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sites': {
      id: '/sites'
      path: '/sites'
      fullPath: '/sites'
      preLoaderRoute: typeof SitesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset': {
      id: '/reset'
      path: '/reset'
      fullPath: '/reset'
      preLoaderRoute: typeof ResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile-auth-challenge': {
      id: '/mobile-auth-challenge'
      path: '/mobile-auth-challenge'
      fullPath: '/mobile-auth-challenge'
      preLoaderRoute: typeof MobileAuthChallengeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot': {
      id: '/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof ForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify/': {
      id: '/verify/'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/': {
      id: '/user/'
      path: '/'
      fullPath: '/user/'
      preLoaderRoute: typeof UserIndexRouteImport
      parentRoute: typeof UserRoute
    }
    '/sites/': {
      id: '/sites/'
      path: '/'
      fullPath: '/sites/'
      preLoaderRoute: typeof SitesIndexRouteImport
      parentRoute: typeof SitesRoute
    }
    '/account/': {
      id: '/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AccountIndexRouteImport
      parentRoute: typeof AccountRoute
    }
    '/verify/$token': {
      id: '/verify/$token'
      path: '/verify/$token'
      fullPath: '/verify/$token'
      preLoaderRoute: typeof VerifyTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/appearance': {
      id: '/user/appearance'
      path: '/appearance'
      fullPath: '/user/appearance'
      preLoaderRoute: typeof UserAppearanceRouteImport
      parentRoute: typeof UserRoute
    }
    '/sites/new': {
      id: '/sites/new'
      path: '/new'
      fullPath: '/sites/new'
      preLoaderRoute: typeof SitesNewRouteImport
      parentRoute: typeof SitesRoute
    }
    '/sites/$siteSlug': {
      id: '/sites/$siteSlug'
      path: '/$siteSlug'
      fullPath: '/sites/$siteSlug'
      preLoaderRoute: typeof SitesSiteSlugRouteImport
      parentRoute: typeof SitesRoute
    }
    '/settings/databases': {
      id: '/settings/databases'
      path: '/settings/databases'
      fullPath: '/settings/databases'
      preLoaderRoute: typeof SettingsDatabasesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/team': {
      id: '/account/team'
      path: '/team'
      fullPath: '/account/team'
      preLoaderRoute: typeof AccountTeamRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/notifications': {
      id: '/account/notifications'
      path: '/notifications'
      fullPath: '/account/notifications'
      preLoaderRoute: typeof AccountNotificationsRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/connections': {
      id: '/account/connections'
      path: '/connections'
      fullPath: '/account/connections'
      preLoaderRoute: typeof AccountConnectionsRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/billing': {
      id: '/account/billing'
      path: '/billing'
      fullPath: '/account/billing'
      preLoaderRoute: typeof AccountBillingRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/api-keys': {
      id: '/account/api-keys'
      path: '/api-keys'
      fullPath: '/account/api-keys'
      preLoaderRoute: typeof AccountApiKeysRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/ai-usage': {
      id: '/account/ai-usage'
      path: '/ai-usage'
      fullPath: '/account/ai-usage'
      preLoaderRoute: typeof AccountAiUsageRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/ai-keys': {
      id: '/account/ai-keys'
      path: '/ai-keys'
      fullPath: '/account/ai-keys'
      preLoaderRoute: typeof AccountAiKeysRouteImport
      parentRoute: typeof AccountRoute
    }
    '/sites/$siteSlug/': {
      id: '/sites/$siteSlug/'
      path: '/'
      fullPath: '/sites/$siteSlug/'
      preLoaderRoute: typeof SitesSiteSlugIndexRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/templates/shared/$token': {
      id: '/templates/shared/$token'
      path: '/templates/shared/$token'
      fullPath: '/templates/shared/$token'
      preLoaderRoute: typeof TemplatesSharedTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sites/$siteSlug/versions': {
      id: '/sites/$siteSlug/versions'
      path: '/versions'
      fullPath: '/sites/$siteSlug/versions'
      preLoaderRoute: typeof SitesSiteSlugVersionsRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/theme': {
      id: '/sites/$siteSlug/theme'
      path: '/theme'
      fullPath: '/sites/$siteSlug/theme'
      preLoaderRoute: typeof SitesSiteSlugThemeRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/settings': {
      id: '/sites/$siteSlug/settings'
      path: '/settings'
      fullPath: '/sites/$siteSlug/settings'
      preLoaderRoute: typeof SitesSiteSlugSettingsRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/search': {
      id: '/sites/$siteSlug/search'
      path: '/search'
      fullPath: '/sites/$siteSlug/search'
      preLoaderRoute: typeof SitesSiteSlugSearchRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/preview': {
      id: '/sites/$siteSlug/preview'
      path: '/preview'
      fullPath: '/sites/$siteSlug/preview'
      preLoaderRoute: typeof SitesSiteSlugPreviewRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/platforms': {
      id: '/sites/$siteSlug/platforms'
      path: '/platforms'
      fullPath: '/sites/$siteSlug/platforms'
      preLoaderRoute: typeof SitesSiteSlugPlatformsRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/migrate': {
      id: '/sites/$siteSlug/migrate'
      path: '/migrate'
      fullPath: '/sites/$siteSlug/migrate'
      preLoaderRoute: typeof SitesSiteSlugMigrateRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/members': {
      id: '/sites/$siteSlug/members'
      path: '/members'
      fullPath: '/sites/$siteSlug/members'
      preLoaderRoute: typeof SitesSiteSlugMembersRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/media': {
      id: '/sites/$siteSlug/media'
      path: '/media'
      fullPath: '/sites/$siteSlug/media'
      preLoaderRoute: typeof SitesSiteSlugMediaRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/bark': {
      id: '/sites/$siteSlug/bark'
      path: '/bark'
      fullPath: '/sites/$siteSlug/bark'
      preLoaderRoute: typeof SitesSiteSlugBarkRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/activitypub': {
      id: '/sites/$siteSlug/activitypub'
      path: '/activitypub'
      fullPath: '/sites/$siteSlug/activitypub'
      preLoaderRoute: typeof SitesSiteSlugActivitypubRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/settings/': {
      id: '/sites/$siteSlug/settings/'
      path: '/'
      fullPath: '/sites/$siteSlug/settings/'
      preLoaderRoute: typeof SitesSiteSlugSettingsIndexRouteImport
      parentRoute: typeof SitesSiteSlugSettingsRoute
    }
    '/sites/$siteSlug/posts/': {
      id: '/sites/$siteSlug/posts/'
      path: '/posts'
      fullPath: '/sites/$siteSlug/posts'
      preLoaderRoute: typeof SitesSiteSlugPostsIndexRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/pages/': {
      id: '/sites/$siteSlug/pages/'
      path: '/pages'
      fullPath: '/sites/$siteSlug/pages'
      preLoaderRoute: typeof SitesSiteSlugPagesIndexRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/forms/': {
      id: '/sites/$siteSlug/forms/'
      path: '/forms'
      fullPath: '/sites/$siteSlug/forms'
      preLoaderRoute: typeof SitesSiteSlugFormsIndexRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/content-types/': {
      id: '/sites/$siteSlug/content-types/'
      path: '/content-types'
      fullPath: '/sites/$siteSlug/content-types'
      preLoaderRoute: typeof SitesSiteSlugContentTypesIndexRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/theme_/design': {
      id: '/sites/$siteSlug/theme_/design'
      path: '/theme/design'
      fullPath: '/sites/$siteSlug/theme/design'
      preLoaderRoute: typeof SitesSiteSlugThemeDesignRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/settings/languages': {
      id: '/sites/$siteSlug/settings/languages'
      path: '/languages'
      fullPath: '/sites/$siteSlug/settings/languages'
      preLoaderRoute: typeof SitesSiteSlugSettingsLanguagesRouteImport
      parentRoute: typeof SitesSiteSlugSettingsRoute
    }
    '/sites/$siteSlug/settings/generation': {
      id: '/sites/$siteSlug/settings/generation'
      path: '/generation'
      fullPath: '/sites/$siteSlug/settings/generation'
      preLoaderRoute: typeof SitesSiteSlugSettingsGenerationRouteImport
      parentRoute: typeof SitesSiteSlugSettingsRoute
    }
    '/sites/$siteSlug/settings/email': {
      id: '/sites/$siteSlug/settings/email'
      path: '/email'
      fullPath: '/sites/$siteSlug/settings/email'
      preLoaderRoute: typeof SitesSiteSlugSettingsEmailRouteImport
      parentRoute: typeof SitesSiteSlugSettingsRoute
    }
    '/sites/$siteSlug/settings/databases': {
      id: '/sites/$siteSlug/settings/databases'
      path: '/databases'
      fullPath: '/sites/$siteSlug/settings/databases'
      preLoaderRoute: typeof SitesSiteSlugSettingsDatabasesRouteImport
      parentRoute: typeof SitesSiteSlugSettingsRoute
    }
    '/sites/$siteSlug/settings/api-keys': {
      id: '/sites/$siteSlug/settings/api-keys'
      path: '/api-keys'
      fullPath: '/sites/$siteSlug/settings/api-keys'
      preLoaderRoute: typeof SitesSiteSlugSettingsApiKeysRouteImport
      parentRoute: typeof SitesSiteSlugSettingsRoute
    }
    '/sites/$siteSlug/posts/new': {
      id: '/sites/$siteSlug/posts/new'
      path: '/posts/new'
      fullPath: '/sites/$siteSlug/posts/new'
      preLoaderRoute: typeof SitesSiteSlugPostsNewRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/posts/$postId': {
      id: '/sites/$siteSlug/posts/$postId'
      path: '/posts/$postId'
      fullPath: '/sites/$siteSlug/posts/$postId'
      preLoaderRoute: typeof SitesSiteSlugPostsPostIdRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/pages/new': {
      id: '/sites/$siteSlug/pages/new'
      path: '/pages/new'
      fullPath: '/sites/$siteSlug/pages/new'
      preLoaderRoute: typeof SitesSiteSlugPagesNewRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/pages/$pageId': {
      id: '/sites/$siteSlug/pages/$pageId'
      path: '/pages/$pageId'
      fullPath: '/sites/$siteSlug/pages/$pageId'
      preLoaderRoute: typeof SitesSiteSlugPagesPageIdRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/forms/new': {
      id: '/sites/$siteSlug/forms/new'
      path: '/forms/new'
      fullPath: '/sites/$siteSlug/forms/new'
      preLoaderRoute: typeof SitesSiteSlugFormsNewRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/forms/$formId': {
      id: '/sites/$siteSlug/forms/$formId'
      path: '/forms/$formId'
      fullPath: '/sites/$siteSlug/forms/$formId'
      preLoaderRoute: typeof SitesSiteSlugFormsFormIdRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/content-types/tables': {
      id: '/sites/$siteSlug/content-types/tables'
      path: '/content-types/tables'
      fullPath: '/sites/$siteSlug/content-types/tables'
      preLoaderRoute: typeof SitesSiteSlugContentTypesTablesRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/content-types/new': {
      id: '/sites/$siteSlug/content-types/new'
      path: '/content-types/new'
      fullPath: '/sites/$siteSlug/content-types/new'
      preLoaderRoute: typeof SitesSiteSlugContentTypesNewRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/content-types/$typeSlug': {
      id: '/sites/$siteSlug/content-types/$typeSlug'
      path: '/content-types/$typeSlug'
      fullPath: '/sites/$siteSlug/content-types/$typeSlug'
      preLoaderRoute: typeof SitesSiteSlugContentTypesTypeSlugRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/forms/$formId/': {
      id: '/sites/$siteSlug/forms/$formId/'
      path: '/'
      fullPath: '/sites/$siteSlug/forms/$formId/'
      preLoaderRoute: typeof SitesSiteSlugFormsFormIdIndexRouteImport
      parentRoute: typeof SitesSiteSlugFormsFormIdRoute
    }
    '/sites/$siteSlug/content-types/tables/': {
      id: '/sites/$siteSlug/content-types/tables/'
      path: '/'
      fullPath: '/sites/$siteSlug/content-types/tables/'
      preLoaderRoute: typeof SitesSiteSlugContentTypesTablesIndexRouteImport
      parentRoute: typeof SitesSiteSlugContentTypesTablesRoute
    }
    '/sites/$siteSlug/pages/$pageId_/design': {
      id: '/sites/$siteSlug/pages/$pageId_/design'
      path: '/pages/$pageId/design'
      fullPath: '/sites/$siteSlug/pages/$pageId/design'
      preLoaderRoute: typeof SitesSiteSlugPagesPageIdDesignRouteImport
      parentRoute: typeof SitesSiteSlugRoute
    }
    '/sites/$siteSlug/forms/$formId/submissions': {
      id: '/sites/$siteSlug/forms/$formId/submissions'
      path: '/submissions'
      fullPath: '/sites/$siteSlug/forms/$formId/submissions'
      preLoaderRoute: typeof SitesSiteSlugFormsFormIdSubmissionsRouteImport
      parentRoute: typeof SitesSiteSlugFormsFormIdRoute
    }
    '/sites/$siteSlug/content-types/tables/$typeSlug': {
      id: '/sites/$siteSlug/content-types/tables/$typeSlug'
      path: '/$typeSlug'
      fullPath: '/sites/$siteSlug/content-types/tables/$typeSlug'
      preLoaderRoute: typeof SitesSiteSlugContentTypesTablesTypeSlugRouteImport
      parentRoute: typeof SitesSiteSlugContentTypesTablesRoute
    }
    '/sites/$siteSlug/content-types/tables/$typeSlug/': {
      id: '/sites/$siteSlug/content-types/tables/$typeSlug/'
      path: '/'
      fullPath: '/sites/$siteSlug/content-types/tables/$typeSlug/'
      preLoaderRoute: typeof SitesSiteSlugContentTypesTablesTypeSlugIndexRouteImport
      parentRoute: typeof SitesSiteSlugContentTypesTablesTypeSlugRoute
    }
    '/sites/$siteSlug/content-types/tables/$typeSlug/new': {
      id: '/sites/$siteSlug/content-types/tables/$typeSlug/new'
      path: '/new'
      fullPath: '/sites/$siteSlug/content-types/tables/$typeSlug/new'
      preLoaderRoute: typeof SitesSiteSlugContentTypesTablesTypeSlugNewRouteImport
      parentRoute: typeof SitesSiteSlugContentTypesTablesTypeSlugRoute
    }
  }
}

interface AccountRouteChildren {
  AccountAiKeysRoute: typeof AccountAiKeysRoute
  AccountAiUsageRoute: typeof AccountAiUsageRoute
  AccountApiKeysRoute: typeof AccountApiKeysRoute
  AccountBillingRoute: typeof AccountBillingRoute
  AccountConnectionsRoute: typeof AccountConnectionsRoute
  AccountNotificationsRoute: typeof AccountNotificationsRoute
  AccountTeamRoute: typeof AccountTeamRoute
  AccountIndexRoute: typeof AccountIndexRoute
}

const AccountRouteChildren: AccountRouteChildren = {
  AccountAiKeysRoute: AccountAiKeysRoute,
  AccountAiUsageRoute: AccountAiUsageRoute,
  AccountApiKeysRoute: AccountApiKeysRoute,
  AccountBillingRoute: AccountBillingRoute,
  AccountConnectionsRoute: AccountConnectionsRoute,
  AccountNotificationsRoute: AccountNotificationsRoute,
  AccountTeamRoute: AccountTeamRoute,
  AccountIndexRoute: AccountIndexRoute,
}

const AccountRouteWithChildren =
  AccountRoute._addFileChildren(AccountRouteChildren)

interface SitesSiteSlugSettingsRouteChildren {
  SitesSiteSlugSettingsApiKeysRoute: typeof SitesSiteSlugSettingsApiKeysRoute
  SitesSiteSlugSettingsDatabasesRoute: typeof SitesSiteSlugSettingsDatabasesRoute
  SitesSiteSlugSettingsEmailRoute: typeof SitesSiteSlugSettingsEmailRoute
  SitesSiteSlugSettingsGenerationRoute: typeof SitesSiteSlugSettingsGenerationRoute
  SitesSiteSlugSettingsLanguagesRoute: typeof SitesSiteSlugSettingsLanguagesRoute
  SitesSiteSlugSettingsIndexRoute: typeof SitesSiteSlugSettingsIndexRoute
}

const SitesSiteSlugSettingsRouteChildren: SitesSiteSlugSettingsRouteChildren = {
  SitesSiteSlugSettingsApiKeysRoute: SitesSiteSlugSettingsApiKeysRoute,
  SitesSiteSlugSettingsDatabasesRoute: SitesSiteSlugSettingsDatabasesRoute,
  SitesSiteSlugSettingsEmailRoute: SitesSiteSlugSettingsEmailRoute,
  SitesSiteSlugSettingsGenerationRoute: SitesSiteSlugSettingsGenerationRoute,
  SitesSiteSlugSettingsLanguagesRoute: SitesSiteSlugSettingsLanguagesRoute,
  SitesSiteSlugSettingsIndexRoute: SitesSiteSlugSettingsIndexRoute,
}

const SitesSiteSlugSettingsRouteWithChildren =
  SitesSiteSlugSettingsRoute._addFileChildren(
    SitesSiteSlugSettingsRouteChildren,
  )

interface SitesSiteSlugContentTypesTablesTypeSlugRouteChildren {
  SitesSiteSlugContentTypesTablesTypeSlugNewRoute: typeof SitesSiteSlugContentTypesTablesTypeSlugNewRoute
  SitesSiteSlugContentTypesTablesTypeSlugIndexRoute: typeof SitesSiteSlugContentTypesTablesTypeSlugIndexRoute
}

const SitesSiteSlugContentTypesTablesTypeSlugRouteChildren: SitesSiteSlugContentTypesTablesTypeSlugRouteChildren =
  {
    SitesSiteSlugContentTypesTablesTypeSlugNewRoute:
      SitesSiteSlugContentTypesTablesTypeSlugNewRoute,
    SitesSiteSlugContentTypesTablesTypeSlugIndexRoute:
      SitesSiteSlugContentTypesTablesTypeSlugIndexRoute,
  }

const SitesSiteSlugContentTypesTablesTypeSlugRouteWithChildren =
  SitesSiteSlugContentTypesTablesTypeSlugRoute._addFileChildren(
    SitesSiteSlugContentTypesTablesTypeSlugRouteChildren,
  )

interface SitesSiteSlugContentTypesTablesRouteChildren {
  SitesSiteSlugContentTypesTablesTypeSlugRoute: typeof SitesSiteSlugContentTypesTablesTypeSlugRouteWithChildren
  SitesSiteSlugContentTypesTablesIndexRoute: typeof SitesSiteSlugContentTypesTablesIndexRoute
}

const SitesSiteSlugContentTypesTablesRouteChildren: SitesSiteSlugContentTypesTablesRouteChildren =
  {
    SitesSiteSlugContentTypesTablesTypeSlugRoute:
      SitesSiteSlugContentTypesTablesTypeSlugRouteWithChildren,
    SitesSiteSlugContentTypesTablesIndexRoute:
      SitesSiteSlugContentTypesTablesIndexRoute,
  }

const SitesSiteSlugContentTypesTablesRouteWithChildren =
  SitesSiteSlugContentTypesTablesRoute._addFileChildren(
    SitesSiteSlugContentTypesTablesRouteChildren,
  )

interface SitesSiteSlugFormsFormIdRouteChildren {
  SitesSiteSlugFormsFormIdSubmissionsRoute: typeof SitesSiteSlugFormsFormIdSubmissionsRoute
  SitesSiteSlugFormsFormIdIndexRoute: typeof SitesSiteSlugFormsFormIdIndexRoute
}

const SitesSiteSlugFormsFormIdRouteChildren: SitesSiteSlugFormsFormIdRouteChildren =
  {
    SitesSiteSlugFormsFormIdSubmissionsRoute:
      SitesSiteSlugFormsFormIdSubmissionsRoute,
    SitesSiteSlugFormsFormIdIndexRoute: SitesSiteSlugFormsFormIdIndexRoute,
  }

const SitesSiteSlugFormsFormIdRouteWithChildren =
  SitesSiteSlugFormsFormIdRoute._addFileChildren(
    SitesSiteSlugFormsFormIdRouteChildren,
  )

interface SitesSiteSlugRouteChildren {
  SitesSiteSlugActivitypubRoute: typeof SitesSiteSlugActivitypubRoute
  SitesSiteSlugBarkRoute: typeof SitesSiteSlugBarkRoute
  SitesSiteSlugMediaRoute: typeof SitesSiteSlugMediaRoute
  SitesSiteSlugMembersRoute: typeof SitesSiteSlugMembersRoute
  SitesSiteSlugMigrateRoute: typeof SitesSiteSlugMigrateRoute
  SitesSiteSlugPlatformsRoute: typeof SitesSiteSlugPlatformsRoute
  SitesSiteSlugPreviewRoute: typeof SitesSiteSlugPreviewRoute
  SitesSiteSlugSearchRoute: typeof SitesSiteSlugSearchRoute
  SitesSiteSlugSettingsRoute: typeof SitesSiteSlugSettingsRouteWithChildren
  SitesSiteSlugThemeRoute: typeof SitesSiteSlugThemeRoute
  SitesSiteSlugVersionsRoute: typeof SitesSiteSlugVersionsRoute
  SitesSiteSlugIndexRoute: typeof SitesSiteSlugIndexRoute
  SitesSiteSlugContentTypesTypeSlugRoute: typeof SitesSiteSlugContentTypesTypeSlugRoute
  SitesSiteSlugContentTypesNewRoute: typeof SitesSiteSlugContentTypesNewRoute
  SitesSiteSlugContentTypesTablesRoute: typeof SitesSiteSlugContentTypesTablesRouteWithChildren
  SitesSiteSlugFormsFormIdRoute: typeof SitesSiteSlugFormsFormIdRouteWithChildren
  SitesSiteSlugFormsNewRoute: typeof SitesSiteSlugFormsNewRoute
  SitesSiteSlugPagesPageIdRoute: typeof SitesSiteSlugPagesPageIdRoute
  SitesSiteSlugPagesNewRoute: typeof SitesSiteSlugPagesNewRoute
  SitesSiteSlugPostsPostIdRoute: typeof SitesSiteSlugPostsPostIdRoute
  SitesSiteSlugPostsNewRoute: typeof SitesSiteSlugPostsNewRoute
  SitesSiteSlugThemeDesignRoute: typeof SitesSiteSlugThemeDesignRoute
  SitesSiteSlugContentTypesIndexRoute: typeof SitesSiteSlugContentTypesIndexRoute
  SitesSiteSlugFormsIndexRoute: typeof SitesSiteSlugFormsIndexRoute
  SitesSiteSlugPagesIndexRoute: typeof SitesSiteSlugPagesIndexRoute
  SitesSiteSlugPostsIndexRoute: typeof SitesSiteSlugPostsIndexRoute
  SitesSiteSlugPagesPageIdDesignRoute: typeof SitesSiteSlugPagesPageIdDesignRoute
}

const SitesSiteSlugRouteChildren: SitesSiteSlugRouteChildren = {
  SitesSiteSlugActivitypubRoute: SitesSiteSlugActivitypubRoute,
  SitesSiteSlugBarkRoute: SitesSiteSlugBarkRoute,
  SitesSiteSlugMediaRoute: SitesSiteSlugMediaRoute,
  SitesSiteSlugMembersRoute: SitesSiteSlugMembersRoute,
  SitesSiteSlugMigrateRoute: SitesSiteSlugMigrateRoute,
  SitesSiteSlugPlatformsRoute: SitesSiteSlugPlatformsRoute,
  SitesSiteSlugPreviewRoute: SitesSiteSlugPreviewRoute,
  SitesSiteSlugSearchRoute: SitesSiteSlugSearchRoute,
  SitesSiteSlugSettingsRoute: SitesSiteSlugSettingsRouteWithChildren,
  SitesSiteSlugThemeRoute: SitesSiteSlugThemeRoute,
  SitesSiteSlugVersionsRoute: SitesSiteSlugVersionsRoute,
  SitesSiteSlugIndexRoute: SitesSiteSlugIndexRoute,
  SitesSiteSlugContentTypesTypeSlugRoute:
    SitesSiteSlugContentTypesTypeSlugRoute,
  SitesSiteSlugContentTypesNewRoute: SitesSiteSlugContentTypesNewRoute,
  SitesSiteSlugContentTypesTablesRoute:
    SitesSiteSlugContentTypesTablesRouteWithChildren,
  SitesSiteSlugFormsFormIdRoute: SitesSiteSlugFormsFormIdRouteWithChildren,
  SitesSiteSlugFormsNewRoute: SitesSiteSlugFormsNewRoute,
  SitesSiteSlugPagesPageIdRoute: SitesSiteSlugPagesPageIdRoute,
  SitesSiteSlugPagesNewRoute: SitesSiteSlugPagesNewRoute,
  SitesSiteSlugPostsPostIdRoute: SitesSiteSlugPostsPostIdRoute,
  SitesSiteSlugPostsNewRoute: SitesSiteSlugPostsNewRoute,
  SitesSiteSlugThemeDesignRoute: SitesSiteSlugThemeDesignRoute,
  SitesSiteSlugContentTypesIndexRoute: SitesSiteSlugContentTypesIndexRoute,
  SitesSiteSlugFormsIndexRoute: SitesSiteSlugFormsIndexRoute,
  SitesSiteSlugPagesIndexRoute: SitesSiteSlugPagesIndexRoute,
  SitesSiteSlugPostsIndexRoute: SitesSiteSlugPostsIndexRoute,
  SitesSiteSlugPagesPageIdDesignRoute: SitesSiteSlugPagesPageIdDesignRoute,
}

const SitesSiteSlugRouteWithChildren = SitesSiteSlugRoute._addFileChildren(
  SitesSiteSlugRouteChildren,
)

interface SitesRouteChildren {
  SitesSiteSlugRoute: typeof SitesSiteSlugRouteWithChildren
  SitesNewRoute: typeof SitesNewRoute
  SitesIndexRoute: typeof SitesIndexRoute
}

const SitesRouteChildren: SitesRouteChildren = {
  SitesSiteSlugRoute: SitesSiteSlugRouteWithChildren,
  SitesNewRoute: SitesNewRoute,
  SitesIndexRoute: SitesIndexRoute,
}

const SitesRouteWithChildren = SitesRoute._addFileChildren(SitesRouteChildren)

interface UserRouteChildren {
  UserAppearanceRoute: typeof UserAppearanceRoute
  UserIndexRoute: typeof UserIndexRoute
}

const UserRouteChildren: UserRouteChildren = {
  UserAppearanceRoute: UserAppearanceRoute,
  UserIndexRoute: UserIndexRoute,
}

const UserRouteWithChildren = UserRoute._addFileChildren(UserRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AccountRoute: AccountRouteWithChildren,
  BillingRoute: BillingRoute,
  ForgotRoute: ForgotRoute,
  LoginRoute: LoginRoute,
  MobileAuthChallengeRoute: MobileAuthChallengeRoute,
  NotificationsRoute: NotificationsRoute,
  RegisterRoute: RegisterRoute,
  ResetRoute: ResetRoute,
  SitesRoute: SitesRouteWithChildren,
  TeamRoute: TeamRoute,
  UserRoute: UserRouteWithChildren,
  VerifyEmailRoute: VerifyEmailRoute,
  InviteTokenRoute: InviteTokenRoute,
  SettingsDatabasesRoute: SettingsDatabasesRoute,
  VerifyTokenRoute: VerifyTokenRoute,
  VerifyIndexRoute: VerifyIndexRoute,
  TemplatesSharedTokenRoute: TemplatesSharedTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
